// import 'react-alice-carousel/lib/alice-carousel.css'
import importAllImg from 'components/importFiles/importAllImg'
import Autoplay from 'embla-carousel-autoplay'
import useEmblaCarousel from 'embla-carousel-react'
import { ReactNode, useCallback, useEffect, useState } from 'react'
import './carousel.scss'

export default function Carousel() {
   const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [Autoplay({ delay: 5000, stopOnInteraction: false })])
   const [items, setItems] = useState<ReactNode[]>([])

   useEffect(() => {
      const visiteurImages = importAllImg(
         require.context('assets/carouselVisiteur', false, /\.(png|jpe?g|svg)$/, 'sync'),
      )

      const visiteurArray = Object.keys(visiteurImages).map((key, index) => {
         return <img key={key} src={visiteurImages[key]} alt={`Diaporama ${index + 1}`} />
      })

      const shuffleArray = (array: any) => {
         for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1))
            ;[array[i], array[j]] = [array[j], array[i]]
         }
      }
      shuffleArray(visiteurArray)
      setItems([...visiteurArray])
   }, [])

   const scrollPrev = useCallback(() => {
      if (emblaApi) emblaApi.scrollPrev()
   }, [emblaApi])

   const scrollNext = useCallback(() => {
      if (emblaApi) emblaApi.scrollNext()
   }, [emblaApi])

   return (
      <div id='embla' >
         <div className='embla__viewport' ref={emblaRef}>
            <div className='embla__container'>
               {items?.map((slide, index) => {
                  return (
                     <div key={slide?.toString()[0] + index.toString()} className='embla__slide'>
                        {slide}
                     </div>
                  )
               })}
            </div>
         </div>
         <img className='embla__prev' src={`${process.env.PUBLIC_URL}/img/arrow-left.png`} onClick={scrollPrev}/>
         <img className='embla__next' src={`${process.env.PUBLIC_URL}/img/arrow-right.png`} onClick={scrollNext}/>
      </div>
   )
}
